import { Reveal, Overline } from "./Reveal";
import { EXPERIENCE } from "../../data/content";

export const Experience = () => (
  <section id="experience" className="relative bg-[#103a2a] py-28 md:py-40">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="mb-20 max-w-3xl">
        <Overline>04 — Professional Experience</Overline>
        <h2 className="mt-6 font-display text-4xl font-bold leading-[1.05] text-white sm:text-5xl lg:text-6xl">
          A career built across
          <br />
          sectors and borders
        </h2>
      </div>

      <div className="border-t border-white/10">
        {EXPERIENCE.map((job, i) => (
          <Reveal key={i} delay={0.04 * i}>
            <div
              data-testid={`experience-${i}`}
              className="group grid grid-cols-1 gap-8 border-b border-white/10 py-12 transition-colors duration-500 hover:bg-[#184a34]/60 md:grid-cols-12 md:py-16"
            >
              <div className="md:col-span-3">
                <span className="font-serif-e text-2xl italic text-[#c9a24e]">
                  {job.period}
                </span>
                {job.place && (
                  <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#52525b]">
                    {job.place}
                  </p>
                )}
              </div>

              <div className="md:col-span-9">
                <h3 className="font-display text-2xl font-bold text-white md:text-3xl">
                  {job.role}
                </h3>
                <p className="mt-1 text-base text-[#c9a24e]">{job.company}</p>
                <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-[#a1a1aa]">
                  {job.summary}
                </p>
                <ul className="mt-7 grid grid-cols-1 gap-x-10 gap-y-3 lg:grid-cols-2">
                  {job.achievements.map((a, j) => (
                    <li key={j} className="flex gap-3 text-sm leading-relaxed text-[#d4d4d8]">
                      <span className="mt-2 h-1 w-1 shrink-0 bg-[#c9a24e]" />
                      <span>{a}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
